import { useContext } from 'react';
import ExpandContext from './expandContext';


const useExpand = () => useContext(ExpandContext); 

export default useExpand;